export const FETCH_GRAPH_DASHBOARD = 'dashboardRRHH/FETCH_GRAPH_DASHBOARD';
export const SET_GRAPH_DASHBOARD = 'dashboardRRHH/SET_GRAPH_DASHBOARD';
export const GET_GRAPH_DASHBOARD = 'dashboardRRHH/GET_GRAPH_DASHBOARD';
